import { getUserId } from '@/utils/auth';
// 初始化时自动从 token 解析 userid
const token = localStorage.getItem('infoToken') || '';
const userId = getUserId(token);

const state = {
  formData: {},
};

const mutations = {
  SET_USER_data(state, data) {
    state.formData = data;
  },
};

const actions = {
  setformData({ commit }, formData) {
    commit('SET_USER_data', formData);
  },
};

const getters = {
  dataList: (state) => state.formData,
  // userid: (state) => state.userid,
};

export default {
  namespaced: true, // 必须开启：避免命名冲突
  state,
  mutations,
  actions,
  getters,
};
